import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Datetime from 'react-datetime'
import 'rc-time-picker/assets/index.css'
import './InputDateField.scss'
import moment from 'moment'

import { isValidTimestamp } from '../../../utils/formUtils'

/**
 * Default function for determining valid date ranges.
 * By default all dates are allowed
 * @returns {boolean}
 */
const defaultValidityFn = () => true

export default class InputDateField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    // TODO: refactor InputDateField such that it holds the date (string or moment) in it's own state, validate itself, and only send onChange when there is a valid date
    fieldValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    required: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func.isRequired,
    linked: PropTypes.bool,
    linkedTrueMessage: PropTypes.string,
    linkedFalseMessage: PropTypes.string,
    onChangeChain: PropTypes.func,
    pickerDisplayTop: PropTypes.bool,
    pickerAlignLeft: PropTypes.bool,
    fieldOnlyBoolean: PropTypes.bool,
    hideTime: PropTypes.bool,
    dateFormat: PropTypes.string,
    validDateFn: PropTypes.func,
    readOnly: PropTypes.bool
  }

  render() {
    let defaultValue

    if (this.props.fieldValue) {
      if (isValidTimestamp(this.props.fieldValue)) {
        defaultValue = this.props.fieldValue
      } else {
        defaultValue = this.props.fieldValue.toString()
      }
    }

    return (
      <div className="input-date group">
        {!this.props.fieldOnlyBoolean ? (
          <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor={this.props.fieldName}>
            {this.props.name}
            {this.props.required ? ' *' : null}
          </label>
        ) : null}
        <div
          className={`input-wrapper ${this.props.pickerDisplayTop === true && 'displayTop'} ${
            this.props.pickerAlignLeft === true && 'alignLeft'
          }`}
        >
          <Datetime
            dateFormat={this.props.dateFormat || 'DD/MM/YYYY'}
            inputProps={{
              id: this.props.fieldName,
              className: `input-field ${this.props.error ? 'error' : ''} ${
                this.props.linked !== undefined ? 'linked-field-input' : ''
              }`,
              autoComplete: 'off',
              disabled: this.props.readOnly === true
            }}
            value={defaultValue}
            timeFormat={!this.props.hideTime && 'HH:mm'}
            onChange={this.handleChangeDate}
            isValidDate={this.props.validDateFn ? this.props.validDateFn : defaultValidityFn}
          />
          {this.props.readOnly !== true ? <div className="linked-field">{this.renderLinkedField()}</div> : null}
        </div>
        {this.props.error && typeof this.props.error === 'string' && (
          <div className="input-error-message">{this.props.error}</div>
        )}
      </div>
    )
  }

  renderLinkedField = () => {
    if (this.props.linked === undefined || this.props.linked === null) {
      return null
    }

    if (this.props.linked) {
      return (
        <i
          className="fa fa-link"
          aria-hidden="true"
          title={this.props.linkedTrueMessage}
          onClick={() => this.props.onChangeChain(false)}
        />
      )
    } else {
      return (
        <i
          className="fa fa-unlink"
          aria-hidden="true"
          title={this.props.linkedFalseMessage}
          onClick={() => this.props.onChangeChain(true)}
        />
      )
    }
  }

  /**
   * Handle a changed date
   * @param {string | import('moment').Moment} date
   */
  handleChangeDate = date => {
    this.props.onChange(dateToTimestamp(date), this.props.fieldName)
  }
}

/**
 * Convert an entered date into a numeric timestamp
 * @param {string | import('moment').Moment} date
 */
function dateToTimestamp(date) {
  if (typeof date.valueOf() === 'number' && date.valueOf().toString().length === 13) {
    return date.valueOf()
  }

  // @ts-ignore TODO refactor this function
  if (date.valueOf().toString().length > 16 && date.trim().valueOf().length === 16) {
    // @ts-ignore TODO refactor this function
    return moment(date.trim().valueOf(), 'DD/MM/YYYY HH:mm').valueOf()
  }

  return date.valueOf()
}
